import store from "../store/index";

// Get print size from setting
export const printSize = () => {
  let size = "";
  store.state.system.settings.print.map((item) => {
    if (item.name == "bill_print") {
      size = item.width;
    }
  });
  console.log(size);
  return size;
};

// let template = [];

// console.log(template);
//Get print setting
let settings = [];
let htmlData = "";
let order_id = "";
let size = 0;
let info = {};

// let cartItemSrow = "";

// let billDetailTitle = "",
//   billDetailData = "",
//   cartHeaderItemFrow = "",
//   cartHeaderItemSrow = "",
//   cartItemFrow = "",
//   headerData = "",
//   cartTotalData = "",
//   cartTotalRupees = "",
//   custPaidData = "",
//   gstHeaderData = "",
//   gstItemsData = "",
//   gstTotalData = "",
//   gstTitle = "",
//   orderSummaryData = "",
//   MOPData = "",
//   payableAmtData = "",
//   termsTitle = "",
//   termsData = "";

// Return Blank space
function getSpace(string, times) {
  if (times > 1) {
    return string.repeat(times);
  } else {
    return "";
  }
}

// Return lines seprator
function getSeprator() {
  let lines = "";
  let length = "";
  console.log(settings);
  settings.map((cool, key) => {
    let item = settings[key];
    lines = item.separator.name;
    length = item.separator.length;
  });
  return lines.repeat(length);
}

const buildHtml = () => {
  settings.map((item) => {
    if (item.key == "store_name") {
      setHtml(item.text);
    } else if (item.key == "address_1") {
      setHtml(item.text);
    } else if (item.key == "location") {
      setHtml(item.text);
    } else if (item.key == "contact_no") {
      setHtml(item.text);
    } else if (item.key == "email") {
      setHtml(item.text);
    } else if (item.key == "gst") {
      setHtml(item.text);
    } else if (item.key == "separator") {
      size = item.text.length;
      setHtml(item.text);
    } else if (item.key == "invoice_title") {
      setHtml(item.text);
    } else if (item.key == "separator") {
      setHtml(item.text);
    } else if (item.key == "invoice_no") {
      invoiceNumber(item.text);
    } else if (item.key == "invoice_date_time") {
      invoiceDateTime(item.text);
    } else if (item.key == "cashier_name") {
      invoiceCashierName(item.text);
    } else if (item.key == "customer_mob") {
      customerMobile(item.text);
    } else if (item.key == "item_header_1") {
      setTableStructure(item.text);
    } else if (item.key == "item_header_2") {
      setTableStructure(item.text);
    } else if (item.key == "item_detail_1") {
      setItemDetails();
    } else if (item.key == "order_total") {
      setOrderTotal(item.text);
    } else if (item.key == "amount_words") {
      setAmountWords(item.text);
    } else if (item.key == "customer_paid") {
      if (info.cash_collected != 0 || info.cash_collected != "0") {
        setCustPaid(item.text);
      }
    } else if (item.key == "balance_refund") {
      if (info.cash_collected != 0 || info.cash_collected != "0") {
        setBalanceRefund(item.text);
      }
    } else if (item.key == "gst_summary") {
      setHtml(item.text.textLeft);
    } else if (item.key == "gst_header") {
      setTableStructure(item.text);
    } else if (item.key == "gst_listing") {
      setGstListing(item.text);
    } else if (item.key == "gst_item") {
      setGstSummary(item.text);
    } else if (item.key == "saving") {
      setSaving(item.text);
    } else if (item.key == "total_qty") {
      setTotalQty(item.text);
    } else if (item.key == "total_sale") {
      setTotalSale(item.text);
    } else if (item.key == "mop") {
      setMop(item.text);
    } else if (item.key == "net_payable") {
      setTotalSale(item.text);
    } else if (item.key == "terms_conditions_header") {
      setHtml(item.text);
    } else if (item.key == "terms") {
      setHtml(item.text);
    }
  });
};

const invoiceNumber = (text) => {
  htmlData += "<pre>" + text.name + order_id + "</pre>";
};

const invoiceDateTime = (text) => {
  htmlData += "<pre>" + text.name + info.date_time + "</pre>";
};

const invoiceCashierName = (text) => {
  htmlData += "<pre>" + text.name + info.cashier_name + "</pre>";
};

const customerMobile = (text) => {
  htmlData += "<pre>" + text.name + info.cust_mob + "</pre>";
};

const setTableStructure = (text) => {
  let data = "";
  text.map((item) => {
    if (item.key == "cess" || item.key == "amount" || item.key == "disc") {
      data += item.name;
      // + getSpace("\x20", item.length - item.name.length);
    } else {
      data += item.name + getSpace("\x20", item.length - item.name.length);
    }
  });
  htmlData += "<pre>" + data + "</pre>";
};

const setItemDetails = (text) => {
  info.pdata.map((item) => {
    let detail_1 = "";
    let detail_2 = "";
    item.detail_1.map((row) => {
      if (row.key == "total") {
        detail_1 += row.name;
        // + getSpace("\x20", row.length - row.name.toString().length);
      } else {
        detail_1 +=
          row.name + getSpace("\x20", row.length - row.name.toString().length);
      }
    });
    htmlData += "<pre>" + detail_1 + "</pre>";
    item.detail_2.map((row) => {
      if (row.key == "discount") {
        detail_2 += row.name;
        // + getSpace("\x20", row.length - row.name.toString().length);
      } else {
        if (row.name == null) {
          row.name = "0";
        }
        detail_2 +=
          row.name + getSpace("\x20", row.length - row.name.toString().length);
      }
    });
    htmlData += "<pre>" + detail_2 + "</pre>";
  });
};

const setOrderTotal = (text) => {
  let data = "";
  text.map((item) => {
    if (item.key == "total") {
      data += item.name + getSpace("\x20", item.length - item.name.length);
    } else if (item.key == "cart_qty") {
      data +=
        info.qty + getSpace("\x20", item.length - info.qty.toString().length);
    } else if (item.key == "total_amount") {
      data +=
        info.total +
        getSpace("\x20", item.length - info.total.toString().length);
    }
  });
  htmlData += "<pre>" + data + "</pre>";
};

const setAmountWords = (text) => {
  htmlData +=
    "<pre>" +
    text.name +
    info.amount_words +
    "Only" +
    getSpace("\x20", size - text.name.length - info.amount_words.length) +
    "</pre>";
};

const setCustPaid = (text) => {
  htmlData +=
    "<pre>" +
    text.name +
    getSpace(
      "\x20",
      size - text.name.length - info.cash_collected.toString().length
    ) +
    info.cash_collected +
    "</pre>";
};

const setBalanceRefund = (text) => {
  let balance_refund = info.balance_refund;
  htmlData +=
    "<pre>" +
    text.name +
    getSpace(
      "\x20",
      size - text.name.length - balance_refund.toString().length
    ) +
    balance_refund +
    "</pre>";
};

const setGstListing = (text) => {
  info.tdata.map((item) => {
    // console.log(item);
    let data = "";
    item.map((taxdata) => {
      if (taxdata.key == "gst_cess") {
        data += parseFloat(taxdata.name).toFixed(2);
        // +
        // getSpace("\x20", taxdata.length - taxdata.name.toString().length);
      } else {
        let round_data = 0;
        if (
          taxdata.key == "gst_cgst" ||
          taxdata.key == "gst_sgst" ||
          taxdata.key == "gst_taxable"
        ) {
          round_data = parseFloat(taxdata.name).toFixed(2);
          data +=
            round_data +
            getSpace("\x20", taxdata.length - round_data.toString().length);
        } else {
          data +=
            taxdata.name +
            getSpace("\x20", taxdata.length - taxdata.name.toString().length);
        }
      }
    });

    if (data != "") {
      htmlData += "<pre>" + data + "</pre>";
    }
  });
};

const setGstSummary = (text) => {
  let data = "";
  text.map((item) => {
    if (item.key == "total") {
      data += item.name + getSpace("\x20", item.length - item.name.length);
    } else if (item.key == "tax_amt") {
      data +=
        parseFloat(info.gst_total.taxable).toFixed(2) +
        getSpace(
          "\x20",
          item.length - info.gst_total.taxable.toString().length
        );
    } else if (item.key == "total_csgt") {
      data +=
        parseFloat(info.gst_total.cgstamt).toFixed(2) +
        getSpace(
          "\x20",
          item.length - info.gst_total.cgstamt.toString().length
        );
    } else if (item.key == "total_sgst") {
      data +=
        parseFloat(info.gst_total.sgstamt).toFixed(2) +
        getSpace(
          "\x20",
          item.length - info.gst_total.sgstamt.toString().length
        );
    } else if (item.key == "total_cess") {
      data += info.gst_total.cessamt;
      //  +
      // getSpace(
      //   "\x20",
      //   item.length - info.gst_total.cessamt.toString().length
      // );
    }
  });
  htmlData += "<pre>" + data + "</pre>";
};

const setSaving = (text) => {
  let leftRightSize =
    text.textLeft.length + info.total_discount.toString().length;
  htmlData +=
    "<pre>" +
    text.textLeft +
    getSpace("\x20", size - leftRightSize) +
    info.total_discount +
    "</pre>";
};

const setTotalQty = (text) => {
  let leftRightSize = text.textLeft.length + info.qty.toString().length;
  htmlData +=
    "<pre>" +
    text.textLeft +
    getSpace("\x20", size - leftRightSize) +
    info.qty +
    "</pre>";
};

const setTotalSale = (text) => {
  let leftRightSize = text.textLeft.length + info.total.toString().length;
  htmlData +=
    "<pre>" +
    text.textLeft +
    getSpace("\x20", size - leftRightSize) +
    info.total +
    "</pre>";
};

const setMop = (text) => {
  info.mop.map((item) => {
    let leftRightSize =
      item.textLeft.toString().length + item.textRight.toString().length;
    htmlData +=
      "<pre>" +
      item.textLeft +
      getSpace("\x20", size - leftRightSize) +
      item.textRight +
      "</pre>";
  });
};

const setHtml = (text) => {
  htmlData += "<pre>" + text + "</pre>";
};

// Inovice Detail
// const invoiceDetailContent = () => {
//   let invoice_content = [],
//     lalign = "",
//     valign = "",
//     data = "";

//   settings.map(item => {
//     if (item.invoice_detail.length > 0) {
//       billDetailTitle = item.invoice_detail[0].title;
//       item.invoice_detail.map(item => {
//         invoice_content.push(item);
//       });
//     }
//   });

//   for (var i = 1; i < invoice_content.length; i++) {
//     if (invoice_content[i].lalign == "center") {
//       lalign = "float-none";
//     } else if (invoice_content[i].lalign == "left") {
//       lalign = "float-left";
//     } else if (invoice_content[i].lalign == "right") {
//       lalign = "float-right";
//     }
//     if (invoice_content[i].valign == "center") {
//       valign = "float-none";
//     } else if (invoice_content[i].valign == "left") {
//       valign = "float-left";
//     } else if (invoice_content[i].valign == "right") {
//       valign = "float-right";
//     }
//     data +=
//       "<tr><td><pre class='coloum text-center'>" +
//       '<span class="' +
//       lalign +
//       '">' +
//       invoice_content[i].label +
//       ": </span>" +
//       '<span class="' +
//       valign +
//       '">' +
//       invoice_content[i].value +
//       "</span>" +
//       "</pre></td></tr>";
//   }

//   billDetailData = data;
// };

// // Cart Header
// const cartHeaderContent = () => {
//   let cartheader_frow_content = [],
//     cartheader_srow_content = [],
//     data = "",
//     datasecond = "";
//   settings.map(item => {
//     if (item.cart_header.hasOwnProperty("first_row")) {
//       item.cart_header.first_row.map(item => {
//         cartheader_frow_content.push(item);
//       });
//     }
//     if (item.cart_header.hasOwnProperty("second_row")) {
//       item.cart_header.second_row.map(item => {
//         cartheader_srow_content.push(item);
//       });
//     }
//   });
//   for (var elements of cartheader_frow_content) {
//     let length = "";
//     length += getSpace("\x20", elements.length);
//     data += elements.name + length;
//     //console.log(cartheader_frow_content)
//   }

//   for (var o in cartheader_srow_content) {
//     let length = "";
//     length += getSpace("\x20", cartheader_srow_content[o].length);
//     datasecond += cartheader_srow_content[o].name + length;
//   }

//   cartHeaderItemFrow = data;
//   cartHeaderItemSrow = datasecond;
// };

// // Cart Item
// const cartItemContent = () => {
//   let cartitem_frow_content = [],
//     cartitem_srow_content = [],
//     data = "",
//     datasecond = "";
//   cartItemSrow = "";
//   settings.map(item => {
//     let cartitem = "";
//     for (var i in item.cart_item) {
//       printCartItems(item.cart_item[i]);
//     }
//   });
// };

// const printCartItems = value => {
//   let data = "";
//   value = JSON.parse(JSON.stringify(value));
//   Object.keys(value).map((item, index) => {
//     data += "<tr><td><pre>";
//     for (var i in value[item]) {
//       let length = "";
//       length += getSpace("\x20", value[item][i].length);
//       data += value[item][i].value + length;
//     }
//     data += "</pre></td></tr>";
//   });
//   cartItemSrow += data;
//   // console.log(cartItemSrow)
// };
// // Cart Total function
// const cartTotal = () => {
//   let title = "",
//     carttotal = [],
//     valign = "",
//     lalign = "",
//     length = "",
//     length2 = "",
//     length3 = "",
//     seconddata = "",
//     data = "";

//   settings.map(item => {
//     item.cart_footer.map(item => {
//       carttotal.push(item);
//     });

//     title = item.grand_total;
//   });

//   if (title.valign == "center") {
//     valign = "text-center";
//   } else if (title.valign == "left") {
//     valign = "text-left";
//   } else if (title.valign == "right") {
//     valign = "text-right";
//   }

//   if (title.lalign == "center") {
//     lalign = "text-center";
//   } else if (title.lalign == "left") {
//     lalign = "text-left";
//   } else if (title.lalign == "right") {
//     lalign = "text-right";
//   }
//   //  first_length +=  getSpace('\xa0',order_content[i].length)

//   length = getSpace("\x20", carttotal[0].length);
//   length2 = getSpace("\x20", carttotal[1].length);
//   length3 = getSpace("\x20", carttotal[2].length);
//   seconddata +=
//     "<tr><td><pre class='coloum '>" +
//     carttotal[0].title +
//     length +
//     +carttotal[1].qty +
//     length2 +
//     length3 +
//     +carttotal[2].total +
//     "</span></pre></td></tr>";

//   data +=
//     "<tr><td><pre class='coloum '>" +
//     '<span class="' +
//     lalign +
//     '">' +
//     title.lable +
//     ":</span>" +
//     '<span class="' +
//     valign +
//     '"> ' +
//     title.value +
//     "</span>" +
//     "</pre></td></tr>";

//   cartTotalRupees = data;
//   cartTotalData = seconddata;
// };

// // Customer paid
// const custPaid = () => {
//   let custpaid_content = [],
//     lalign = "",
//     valign = "",
//     data = "";

//   settings.map(item => {
//     if (item.customer_paid.length > 0) {
//       item.customer_paid.map(item => {
//         custpaid_content.push(item);
//       });
//     }
//   });

//   for (var i in custpaid_content) {
//     if (custpaid_content[i].lalign == "center") {
//       lalign = "float-none";
//     } else if (custpaid_content[i].lalign == "left") {
//       lalign = "float-left";
//     } else if (custpaid_content[i].lalign == "right") {
//       lalign = "float-right";
//     }
//     if (custpaid_content[i].valign == "center") {
//       valign = "float-none";
//     } else if (custpaid_content[i].valign == "left") {
//       valign = "float-left";
//     } else if (custpaid_content[i].valign == "right") {
//       valign = "float-right";
//     }
//     data +=
//       "<tr><td><pre class='coloum text-center'>" +
//       '<span class="' +
//       lalign +
//       '">' +
//       custpaid_content[i].lable +
//       ": </span>" +
//       '<span class="' +
//       valign +
//       '">' +
//       custpaid_content[i].value +
//       "</span>" +
//       "</pre></td></tr>";
//   }

//   custPaidData = data;
// };

// // GST Header
// const gstContent = () => {
//   let gstheader_content = [],
//     gst_content = [],
//     title = "",
//     valign = "",
//     data = "",
//     datasecond = "",
//     datathird = "";

//   settings.map(item => {
//     title = item.gst_header[0];

//     if (item.gst_header.hasOwnProperty("first_row")) {
//       item.gst_header.first_row.map(item => {
//         gstheader_content.push(item);
//       });
//     }

//     item.gst_item.map(item => {
//       console.log(item);
//       let data = {};
//       data.first_row = item.first_row;
//       gst_content.push(data);
//     });
//   });
//   for (var i in gstheader_content) {
//     let length = "";
//     length += getSpace("\x20", gstheader_content[i].length);
//     data += gstheader_content[i].name + length;
//   }
//   gst_content.map(item => {
//     datathird += "<pre>";
//     item.first_row.map(gstitem => {
//       let length = "";
//       length += getSpace("\x20", gstitem.length);
//       datathird += gstitem.value + length;
//     });
//     datathird += "</pre>";
//   });

//   if (title.valign == "center") {
//     valign = "text-center";
//   } else if (title.valign == "left") {
//     valign = "text-left";
//   } else if (title.valign == "right") {
//     valign = "text-right";
//   } else if (title.valign == "") {
//     valign = "text-center";
//   }
//   datasecond +=
//     "<tr><td><pre class='coloum '>" +
//     '<span class="' +
//     valign +
//     '" style="display:block">' +
//     title.title +
//     ": </span>" +
//     "</pre></td></tr>";

//   gstTitle = datasecond;
//   gstHeaderData = data;
//   gstItemsData = datathird;
// };

// // GST Total
// const gstTotal = () => {
//   let order_content = [],
//     lalign = "",
//     valign = "",
//     data = "";

//   settings.map(item => {
//     if (item.order_total.length > 0) {
//       item.order_total.map(item => {
//         order_content.push(item);
//       });
//     }
//   });

//   for (var i in order_content) {
//     let length = "";
//     length += getSpace("\x20", order_content[i].length);
//     data += order_content[i].name + length;
//   }
//   gstTotalData = data;
// };

// // Order Summary
// const orderSummary = () => {
//   let order_summary = [],
//     lalign = "",
//     valign = "",
//     data = "";

//   settings.map(item => {
//     if (item.order_summary.length > 0) {
//       item.order_summary.map(item => {
//         order_summary.push(item);
//       });
//     }
//   });

//   for (var i in order_summary) {
//     if (order_summary[i].lalign == "center") {
//       lalign = "float-none";
//     } else if (order_summary[i].lalign == "left") {
//       lalign = "float-left";
//     } else if (order_summary[i].lalign == "right") {
//       lalign = "float-right";
//     }
//     if (order_summary[i].valign == "center") {
//       valign = "float-none";
//     } else if (order_summary[i].valign == "left") {
//       valign = "float-left";
//     } else if (order_summary[i].valign == "right") {
//       valign = "float-right";
//     }
//     data +=
//       "<tr><td><pre class='coloum'>" +
//       '<span class="' +
//       lalign +
//       '">' +
//       order_summary[i].label +
//       ": </span>" +
//       '<span class="' +
//       valign +
//       '">' +
//       order_summary[i].value +
//       "</span>" +
//       "</pre></td></tr>";
//   }
//   console.log(data);
//   orderSummaryData = data;
// };

// // Mode of payment
// const modeofPay = () => {
//   let mop = [],
//     lalign = "",
//     valign = "",
//     data = "";

//   settings.map(item => {
//     if (item.payment_meth.length > 0) {
//       item.payment_meth.map(item => {
//         mop.push(item);
//       });
//     }
//   });

//   for (var i in mop) {
//     if (mop[i].lalign == "center") {
//       lalign = "float-none";
//     } else if (mop[i].lalign == "left") {
//       lalign = "float-left";
//     } else if (mop[i].lalign == "right") {
//       lalign = "float-right";
//     }
//     if (mop[i].valign == "center") {
//       valign = "float-none";
//     } else if (mop[i].valign == "left") {
//       valign = "float-left";
//     } else if (mop[i].valign == "right") {
//       valign = "float-right";
//     }
//     data +=
//       "<tr><td><pre class='coloum'>" +
//       '<span class="' +
//       lalign +
//       '">' +
//       mop[i].label +
//       ": </span>" +
//       '<span class="' +
//       valign +
//       '">' +
//       mop[i].value +
//       "</span>" +
//       "</pre></td></tr>";
//   }

//   MOPData = data;
// };

// // Payable amount
// const payableAmount = () => {
//   let payAmount = [],
//     lalign = "",
//     valign = "",
//     data = "";

//   settings.map(item => {
//     if (item.payable_amt.length > 0) {
//       item.payable_amt.map(item => {
//         payAmount.push(item);
//       });
//     }
//   });

//   for (var i in payAmount) {
//     if (payAmount[i].lalign == "center") {
//       lalign = "float-none";
//     } else if (payAmount[i].lalign == "left") {
//       lalign = "float-left";
//     } else if (payAmount[i].lalign == "right") {
//       lalign = "float-right";
//     }
//     if (payAmount[i].valign == "center") {
//       valign = "float-none";
//     } else if (payAmount[i].valign == "left") {
//       valign = "float-left";
//     } else if (payAmount[i].valign == "right") {
//       valign = "float-right";
//     }
//     data +=
//       "<tr><td><pre class='coloum'>" +
//       '<span class="' +
//       lalign +
//       '">' +
//       payAmount[i].label +
//       ": </span>" +
//       '<span class="' +
//       valign +
//       '">' +
//       payAmount[i].value +
//       "</span>" +
//       "</pre></td></tr>";
//   }

//   payableAmtData = data;
// };

// // Inovice Detail
// const termsConditions = () => {
//   let terms_content = [],
//     lalign = "",
//     valign = "",
//     data = "";

//   settings.map(item => {
//     if (item.bill_footer.hasOwnProperty("terms_conditions")) {
//       termsTitle = item.bill_footer.terms_conditions[0].title;
//       item.bill_footer.terms_conditions.map(item => {
//         terms_content.push(item);
//       });
//     }
//   });

//   for (var i = 1; i < terms_content.length; i++) {
//     if (terms_content[i].hasOwnProperty("align")) {
//       if (terms_content[i].align == "center") {
//         lalign = "float-none";
//       } else if (terms_content[i].align == "left") {
//         lalign = "float-left";
//       } else if (terms_content[i].align == "right") {
//         lalign = "float-right";
//       }
//     }

//     data +=
//       "<tr><td><pre class='coloum'>" +
//       terms_content[i].name +
//       "</pre></td></tr>";
//   }

//   termsData = data;
// };

let htmlOutput = (data_order_id, template, p_info) => {
  settings = template;
  order_id = data_order_id;
  info = p_info;
  htmlData = "";
  buildHtml();

  let HTML = "";

  // storeDetails();
  // invoiceDetailContent();
  // cartHeaderContent();
  // cartTotal();
  // orderSummary();
  // custPaid();
  // cartItemContent();
  // gstContent();
  // gstTotal();
  // modeofPay();
  // payableAmount();
  // termsConditions();

  HTML = "<div>" + htmlData + "</div>";

  // let HTML =
  //   "<div class='offline-print' style='width:350px; margin:0 auto; text-center'><table>" +
  //   headerData +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre style='text-align:center'>" +
  //   billDetailTitle +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   billDetailData +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre>" +
  //   cartHeaderItemFrow +
  //   "<br/>" +
  //   cartHeaderItemSrow +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   cartItemSrow +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   cartTotalData +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   cartTotalRupees +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   custPaidData +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   gstTitle +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre>" +
  //   gstHeaderData +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   "<tr><td>" +
  //   gstItemsData +
  //   "</td></tr>" +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre>" +
  //   gstTotalData +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   orderSummaryData +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   MOPData +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   payableAmtData +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre>" +
  //   termsTitle +
  //   "</pre></td></tr>" +
  //   "<tr><td><pre>" +
  //   // getSeprator() +
  //   "</pre></td></tr>" +
  //   termsData +
  //   "</table></div>";

  // let PrintData = document.getElementById('app').innerHTML = HTML;

  return HTML;
};

export default {
  htmlOutput,
};
